export const NameAndDescriptionPattern = new RegExp('(?![-_+:.,\\dа-яёА-ЯЁa-zA-Z ]).', 'gmi');
